import { Popper } from '../Popper';
import { ViewPopoverContent } from '../../views/ViewPopoverContent';
export var PopoverContent = Popper.withPopperContent(ViewPopoverContent);